import React, { useState, useEffect } from 'react';

import TopBar from 'TopBar'
import SummaryPanel from './assets/SummaryPanel';
import Gallery from 'Gallery';
import Popup from 'Popup'

import { AppContext } from 'AppContext'

// if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
//   import fullDataset from 'data'
// } else {
//   // production code
//   let resp = await fetch('https://magicbox-dashboard.herokuapp.com/data')
//   const fullDataset = await resp.json()
//   console.log(fullDataset)
// }

function App() {

  const [loading, setLoading] =  useState(true)
  const [popupOpen, setPopupOpen] = useState(false)
  const [currentPic, setCurrentPic] = useState({})
  const [fullDataset, setFullDataset] = useState({})
  const [data, setData] = useState([])
  const [threshold, setThreshold] = useState(75)

  const [accepted, setAccepted] = useState(0)

  const tick = (threshold) => {
    setData(prevData => {
      const newData = fullDataset.slice(0, Math.min(prevData.length + 1, fullDataset.length))
      const amount = newData.filter((el) => el.scratch < threshold).length
      setAccepted(amount)
      return newData
    })
}
  useEffect(() => {
    if (loading) return
    //run instantly
    tick(threshold);
    const interval = setInterval(() => {
      //every 10 seconds
      tick(threshold);
    }, 3000);
    return () => clearInterval(interval);
  }, [loading]);

  useEffect(() => {
    const amount = data.filter((el) => el.scratch < threshold).length
    setAccepted(amount)
  }, [threshold])

  useEffect(async () => {
      // production code
      let resp = await fetch('https://magicbox-dashboard.herokuapp.com/data/')
      const dataset = await resp.json()
      console.log(dataset)
      setFullDataset(dataset)
      setData(dataset.slice(0, 15))
      setLoading(false)
  }, [])

  if (loading) {
    return <p> Loading, please wait! </p>
  }

  return (

    <AppContext.Provider value={{
      currentPic,
      setCurrentPic,
      popupOpen,
      setPopupOpen,
      data,
      setData,
      threshold,
      setThreshold,
      accepted
    }}>

      <div className="flex relative w-100 h-full bg-gray-900">
        {popupOpen && <Popup />}
        <div className="flex w-3/4 flex-col flex-auto p-4 divide-y divide-gray-700">
          <TopBar />
          <Gallery className="flex-grow" />
          {/* </div> */}
        </div>
        <div className="w-1/4 bg-gray-800 p-4">
          <SummaryPanel />
        </div>
      </div>

    </AppContext.Provider>
  );
}

export default App;
